var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Location",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(5.000000, 2.000000)",
    fill: "#e82121",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53162364,0.93677136 C5.71648131,-0.332725549 8.40202895,-0.310536831 10.5663829,0.994894436 C12.7094606,2.32691389 14.0119656,4.70417621 13.9999171,7.2614437 C13.9499525,9.80193665 12.5532948,12.19 10.8074726,14.0360916 C9.79983405,15.1064007 8.67261414,16.0528287 7.44884341,16.8560387 C7.32280695,16.9289175 7.18475052,16.9777069 7.04148491,17 C6.90359952,16.9941293 6.76931787,16.9533854 6.65075329,16.8814437 C4.78242676,15.6745675 3.14333538,14.1340363 1.81233196,12.3339613 C0.698588545,10.8313638 0.0658356762,9.01600687 1.16173251e-06,7.13441906 L1.16173251e-06,7.13441906 L0.00498738283,6.86069219 C0.0959232361,4.40464541 1.42479659,2.16092909 3.53162364,0.93677136 Z M7.90726427,5.03477398 C7.01907148,4.65723455 5.99504406,4.86234968 5.31331796,5.5543476 C4.63159185,6.24634553 4.42664239,7.28872472 4.794164,8.19478048 C5.1616856,9.10083625 6.029182,9.69184263 6.99160428,9.69184862 C7.62210424,9.69637563 8.22818849,9.44382725 8.67481048,8.99047584 C9.12143248,8.53712442 9.37148354,7.92063779 9.36926261,7.27838032 C9.37261286,6.29803506 8.79545706,5.41231342 7.90726427,5.03477398 Z",
    id: "Path_34175"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_743",
    opacity: 0.400000006,
    cx: 7,
    cy: 19,
    rx: 5,
    ry: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.b48393a0e124e329772ddbfe0920a809.svg";
export { ForwardRef as ReactComponent };